import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  return <section className="py-12 sm:py-24 px-4 sm:px-6 lg:px-8 bg-sage text-white text-center relative overflow-hidden" data-id="element-13">
      <div className="absolute inset-0 bg-charcoal/10" data-id="element-14"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-2xl sm:text-5xl font-bold mb-6 sm:mb-10 leading-tight" data-id="element-17">
            Tienes dos caminos...
          </h2>

          <div className="grid sm:grid-cols-2 gap-4 sm:gap-8 mb-8 sm:mb-12 text-left" data-id="element-18">
            <div className="bg-white/10 backdrop-blur-sm p-5 sm:p-8 rounded-xl sm:rounded-2xl border border-white/20" data-id="element-19">
              <h3 className="font-bold text-base sm:text-xl mb-2 sm:mb-4 text-cream" data-id="element-20">
                Camino 1:
              </h3>
              <p className="text-white/80 leading-relaxed text-sm sm:text-base" data-id="element-21">
                Seguir como hasta ahora, despertándote cansada, con sudoraciones
                y sintiendo que tu cuerpo ya no te pertenece...
              </p>
            </div>

            <div className="bg-white p-5 sm:p-8 rounded-xl sm:rounded-2xl shadow-xl sm:transform sm:-translate-y-4 border-2 border-accent relative" data-id="element-22">
              <div className="absolute -top-3 -right-3 bg-accent text-white text-xs font-bold px-2 sm:px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-23">
                Recomendado
              </div>
              <h3 className="font-bold text-base sm:text-xl mb-2 sm:mb-4 text-charcoal" data-id="element-24">
                Camino 2:
              </h3>
              <p className="text-charcoal-light leading-relaxed text-sm sm:text-base" data-id="element-25">
                Tomar el camino del{' '}
                <strong className="text-sage-dark" data-id="element-26">Reinicio Hormonal</strong> y
                descubrir lo que se siente vivir sin inflamación y con alegría.
              </p>
            </div>
          </div>

          <p className="text-base sm:text-xl font-serif italic text-cream mb-6 sm:mb-10" data-id="element-27">
            La decisión es tuya, pero el descuento termina pronto.
          </p>

          <CTAButton className="sm:scale-110 shadow-2xl" data-id="element-28" />
        </FadeIn>
      </div>
    </section>;
}